<template>
  <div class="admin">
    <el-container direction="vertical">
      <el-header :height="`${headerHeight}px`" class="admin__header fn-clear">
        <div class="admin__header-left">
          <img src="@/assets/images/logo.png" />
        </div>
        <div class="admin__header-right">
          <span>{{ loginBackDate }}</span>
          <span>当前账号：{{ userName }}</span>
          <el-button
            type="info"
            icon="el-icon-switch-button"
            circle
            @click="handleLogOut"
          ></el-button>
        </div>
      </el-header>
      <el-container>
        <el-aside
          class="admin__aside"
          width="200px"
          :style="`min-height:100vh;`"
        >
          <el-menu
            :default-active="menuIndex"
            class="admin__aside-menu"
            :unique-opened="true"
            background-color="#304156"
            text-color="#ffffff"
            active-text-color="#1977ff"
            @select="handleMenu"
          >
            <el-submenu
              v-for="(item1, idx1) in menuSource"
              :key="idx1"
              :index="item1.name"
            >
              <template slot="title">
                <i :class="iconMatch[item1.name]"></i>
                <span>{{ item1.name }}</span>
              </template>
              <el-menu-item
                v-for="(item2, idx2) in item1.childrenModel"
                :key="idx2"
                :index="item2.name"
                >{{ item2.name }}</el-menu-item
              >
            </el-submenu>

            <template v-if="false">
              <el-submenu index="数据源管理">
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <span>数据源管理</span>
                </template>
                <el-menu-item index="成果管理">成果管理</el-menu-item>
                <el-menu-item index="需求管理">需求管理</el-menu-item>
                <el-menu-item index="专利管理">专利管理</el-menu-item>
                <el-menu-item index="案例管理">案例管理</el-menu-item>
              </el-submenu>
              <el-submenu index="推荐管理">
                <template slot="title">
                  <i class="el-icon-news"></i>
                  <span>推荐管理</span>
                </template>
                <el-menu-item index="搜索关键词推荐"
                  >搜索关键词推荐</el-menu-item
                >
                <el-menu-item index="首页推荐">首页推荐</el-menu-item>
              </el-submenu>
              <el-submenu index="数据对接管理">
                <template slot="title">
                  <i class="el-icon-finished"></i>
                  <span>数据对接管理</span>
                </template>
                <el-menu-item index="成果对接管理">成果对接管理</el-menu-item>
                <el-menu-item index="需求对接管理">需求对接管理</el-menu-item>
                <el-menu-item index="专利对接管理">专利对接管理</el-menu-item>
              </el-submenu>
              <el-submenu index="解决方案管理">
                <template slot="title">
                  <i class="el-icon-s-platform"></i>
                  <span>解决方案管理</span>
                </template>
                <el-menu-item index="案例咨询管理">案例咨询管理</el-menu-item>
              </el-submenu>
              <el-submenu index="服务管理">
                <template slot="title">
                  <i class="el-icon-service"></i>
                  <span>服务管理</span>
                </template>
                <el-menu-item index="专利服务咨询管理"
                  >专利服务咨询管理</el-menu-item
                >
                <el-menu-item index="金融服务咨询管理"
                  >金融服务咨询管理</el-menu-item
                >
                <el-menu-item index="标准服务咨询管理"
                  >标准服务咨询管理</el-menu-item
                >
                <el-menu-item index="资质申请管理">资质申请管理</el-menu-item>
                <el-menu-item index="服务需求对接管理"
                  >服务需求对接管理</el-menu-item
                >
              </el-submenu>
              <el-submenu index="专家管理">
                <template slot="title">
                  <i class="el-icon-s-check"></i>
                  <span>专家管理</span>
                </template>
                <el-menu-item index="专家信息">专家信息</el-menu-item>
                <el-menu-item index="服务信息">服务信息</el-menu-item>
                <el-menu-item index="服务申请">服务申请</el-menu-item>
              </el-submenu>
              <el-submenu index="政策之窗管理">
                <template slot="title">
                  <i class="el-icon-s-flag"></i>
                  <span>政策之窗管理</span>
                </template>
                <el-menu-item index="政策通知管理">政策通知管理</el-menu-item>
                <el-menu-item index="政策解读管理">政策解读管理</el-menu-item>
                <el-menu-item index="项目管理">项目管理</el-menu-item>
                <el-menu-item index="项目申报管理">项目申报管理</el-menu-item>
                <el-menu-item index="申报公示管理">申报公示管理</el-menu-item>
              </el-submenu>
              <el-submenu index="活动资讯信息管理">
                <template slot="title">
                  <i class="el-icon-s-order"></i>
                  <span>活动资讯信息管理</span>
                </template>
                <el-menu-item index="活动信息管理">活动信息管理</el-menu-item>
                <!-- <el-menu-item index="活动参加单位管理"
                >活动参加单位管理</el-menu-item
              >
              <el-menu-item index="活动报名管理">活动报名管理</el-menu-item> -->
                <el-menu-item index="新闻信息管理">新闻信息管理</el-menu-item>
              </el-submenu>
              <el-submenu index="专题赛管理">
                <template slot="title">
                  <i class="el-icon-bank-card"></i>
                  <span>专题赛管理</span>
                </template>
                <el-menu-item index="专题赛咨询">专题赛咨询</el-menu-item>
                <!-- <el-menu-item index="专题赛通知公告">专题赛通知公告</el-menu-item>
              <el-menu-item index="专题赛活动">专题赛活动</el-menu-item>
              <el-menu-item index="专题赛需求">专题赛需求</el-menu-item>
              <el-menu-item index="专题赛企业解决方案"
                >专题赛企业解决方案</el-menu-item
              >
              <el-menu-item index="专题赛企业服务">专题赛企业服务</el-menu-item> -->
              </el-submenu>
              <el-submenu index="用户管理">
                <template slot="title">
                  <i class="el-icon-user"></i>
                  <span>用户管理</span>
                </template>
                <el-menu-item index="用户信息管理">用户信息管理</el-menu-item>
                <el-menu-item index="已认证用户列表"
                  >已认证用户列表</el-menu-item
                >
              </el-submenu>
              <el-submenu index="系统管理">
                <template slot="title">
                  <i class="el-icon-setting"></i>
                  <span>系统管理</span>
                </template>
                <el-menu-item index="消息提醒">消息提醒</el-menu-item>
              </el-submenu>
              <el-submenu index="权限管理">
                <template slot="title">
                  <i class="el-icon-key"></i>
                  <span>权限管理</span>
                </template>
                <el-menu-item index="角色管理">角色管理</el-menu-item>
                <el-menu-item index="账号管理">账号管理</el-menu-item>
                <el-menu-item index="部门管理">部门管理</el-menu-item>
              </el-submenu>
              <el-submenu index="平台统计">
                <template slot="title">
                  <i class="el-icon-s-marketing"></i>
                  <span>平台统计</span>
                </template>
                <el-menu-item index="统计总览">统计总览</el-menu-item>
              </el-submenu>
              <el-submenu index="加工资源填报管理">
                <template slot="title">
                  <i class="el-icon-notebook-2"></i>
                  <span>加工资源填报管理</span>
                </template>
                <el-menu-item index="零部件加工企业填报"
                  >零部件加工企业填报</el-menu-item
                >
                <el-menu-item index="机器人企业填报"
                  >机器人企业填报</el-menu-item
                >
              </el-submenu>
            </template>
          </el-menu>
        </el-aside>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "admin",
  data() {
    return {
      loginBackDate: "",
      userName: "",
      headerHeight: 80,
      iconMatch: {
        平台统计: "el-icon-s-marketing",
        数据源管理: "el-icon-menu",
        推荐管理: "el-icon-news",
        数据对接管理: "el-icon-finished",
        解决方案管理: "el-icon-s-platform",
        服务管理: "el-icon-service",
        专家管理: "el-icon-s-check",
        政策之窗管理: "el-icon-s-flag",
        加工资源填报管理: "el-icon-notebook-2",
        活动资讯信息管理: "el-icon-s-order",
        专题赛管理: "el-icon-bank-card",
        用户管理: "el-icon-user",
        系统管理: "el-icon-setting",
        权限管理: "el-icon-key"
      },
      menuSource: [],
      menuIndex: "",
      menuList: [
        {
          name: "统计总览",
          url: "/admin/statisticsManage",
          reg: /statistics/
        },
        {
          name: "成果管理",
          url: "/admin/dataManage/achievementList",
          reg: /achievement/
        },
        {
          name: "需求管理",
          url: "/admin/dataManage/demandList",
          reg: /demand/
        },
        {
          name: "专利管理",
          url: "/admin/dataManage/patentList",
          reg: /patent/
        },
        {
          name: "案例管理",
          url: "/admin/dataManage/typicalCaseList",
          reg: /typicalCase/
        },
        {
          name: "搜索关键词推荐",
          url: "/admin/recommendManage/keywordRecommend",
          reg: /keywordRecommend/
        },
        {
          name: "首页推荐",
          url: "/admin/recommendManage/homepageRecommend",
          reg: /homepageRecommend/
        },
        {
          name: "成果对接管理",
          url: "/admin/dockingManage/achDockingList",
          reg: /achDocking/
        },
        {
          name: "需求对接管理",
          url: "/admin/dockingManage/demDockingList",
          reg: /demDocking/
        },
        {
          name: "专利对接管理",
          url: "/admin/dockingManage/patDockingList",
          reg: /patDocking/
        },
        {
          name: "政策通知管理",
          url: "/admin/policyManage/policyMessageList",
          reg: /policyMessage/
        },
        {
          name: "政策解读管理",
          url: "/admin/policyManage/policyExplainList",
          reg: /policyExplain/
        },
        {
          name: "项目管理",
          url: "/admin/policyManage/projectMessageList",
          reg: /projectMessage/
        },
        {
          name: "项目申报管理",
          url: "/admin/policyManage/projectDeclareList",
          reg: /projectDeclare/
        },
        {
          name: "申报公示管理",
          url: "/admin/policyManage/projectPublicityList",
          reg: /projectPublicity/
        },
        {
          name: "零部件加工企业填报",
          url: "/admin/machiningManage/machiningComponentList",
          reg: /machiningComponent/
        },
        {
          name: "机器人企业填报",
          url: "/admin/machiningManage/machiningRobotList",
          reg: /machiningRobot/
        },
        {
          name: "专利服务咨询管理",
          url: "/admin/serviceManage/patServiceList",
          reg: /patService/
        },
        {
          name: "金融服务咨询管理",
          url: "/admin/serviceManage/financeServiceList",
          reg: /financeService/
        },
        {
          name: "标准服务咨询管理",
          url: "/admin/serviceManage/standardServiceList",
          reg: /standardService/
        },
        {
          name: "资质申请管理",
          url: "/admin/serviceManage/qualificationApplyList",
          reg: /qualificationApply/
        },
        {
          name: "资质评估管理",
          url: "/admin/serviceManage/qualificationEvaluateList",
          reg: /qualificationEvaluate/
        },
        {
          name: "服务需求对接管理",
          url: "/admin/serviceManage/serviceCaseList",
          reg: /serviceCase/
        },
        {
          name: "专家信息",
          url: "/admin/expertManage/expertMessageList",
          reg: /expertMessage/
        },
        {
          name: "服务信息",
          url: "/admin/expertManage/expertServiceMessageList",
          reg: /expertServiceMessage/
        },
        {
          name: "服务申请",
          url: "/admin/expertManage/expertServiceApplyList",
          reg: /expertServiceApply/
        },
        {
          name: "案例咨询管理",
          url: "/admin/solutionManage/solutionCaseList",
          reg: /solutionCase/
        },
        {
          name: "活动信息管理",
          url: "/admin/activityManage/activityMessageList",
          reg: /activityMessage/
        },
        {
          name: "活动参加单位管理",
          url: "/admin/activityManage/activityCompanyList",
          reg: /activityCompany/
        },
        {
          name: "活动报名管理",
          url: "/admin/activityManage/activityApplyList",
          reg: /activityApply/
        },
        {
          name: "新闻信息管理",
          url: "/admin/activityManage/newsList",
          reg: /news/
        },
        {
          name: "专题赛咨询",
          url: "/admin/competitionManage/contestApplyList",
          reg: /contestApply/
        },
        {
          name: "专题赛通知公告",
          url: "/admin/competitionManage/contestNoticeList",
          reg: /contestNotice/
        },
        {
          name: "专题赛活动",
          url: "/admin/competitionManage/contestActivityList",
          reg: /contestActivity/
        },
        {
          name: "专题赛需求",
          url: "/admin/competitionManage/contestDemList",
          reg: /contestDem/
        },
        {
          name: "专题赛企业解决方案",
          url: "/admin/competitionManage/contestSolutionList",
          reg: /contestSolution/
        },
        {
          name: "专题赛企业服务",
          url: "/admin/competitionManage/contestServiceList",
          reg: /contestService/
        },

        {
          name: "用户信息管理",
          url: "/admin/userManage/userContentlist",
          reg: /userContent/i
        },
        {
          name: "已认证用户列表",
          url: "/admin/userManage/userCertifiedist",
          reg: /userCertified/i
        },
        {
          name: "消息提醒",
          url: "/admin/systemManage/notificationList",
          reg: /notification/i
        },
        {
          name: "角色管理",
          url: "/admin/privilegeManage/roleList",
          reg: /role/i
        },
        {
          name: "账号管理",
          url: "/admin/privilegeManage/accountList",
          reg: /account/i
        },
        {
          name: "部门管理",
          url: "/admin/privilegeManage/departmentList",
          reg: /department/i
        }
      ]
    };
  },
  computed: {
    asideHeight() {
      return window.innerHeight - this.headerHeight;
    }
  },
  watch: {
    $route: "onRouter"
  },
  created() {
    const time = this.$cookies.get("loginBackDate");
    this.loginBackDate = time ? `登录时间： ${time}` : "";
    this.loadMenu();
  },
  methods: {
    handleLogOut() {
      this.$cookies.remove("backToken");
      this.$cookies.remove("loginBackDate");
      this.redirectByPath("/");
    },
    // 加载用户有访问权限的菜单
    loadMenu() {
      this.$api("user", "getMenu", {}).then((res) => {
        this.userName = res.userName;
        this.menuSource = res.dataList;
        // 如果在首页 需要先判定初始路由 跳转到页面后 根据监听路由再设置menuIndex
        if (this.$route.path === "/admin") {
          this.setFirstMenu();
        } else {
          // 在其他页面直接设置menuIndex
          this.onRouter();
        }
      });
    },
    // 在首页时 根据用户有访问权限的菜单设置初始路由
    setFirstMenu() {
      if (this.menuSource.length > 0) {
        const first = this.menuSource[0].childrenModel[0].name;
        this.menuList.some((item) => {
          var bool = item.name === first;
          if (bool) {
            this.redirectByPath(item.url);
            return true;
          }
        });
      }
    },
    // 监听路由的变化
    onRouter() {
      // 如果重新返回首页 意味着用户访问权限发生变化 需要重新加载菜单再设置
      if (this.$route.path === "/admin") {
        this.loadMenu();
      } else {
        // 直接设置menuIndex
        this.menuList.some((item) => {
          var bool = item.reg.test(this.$route.path);
          if (bool) {
            this.menuIndex = item.name;
            return true;
          }
        });
      }
    },
    // 点击切换菜单
    handleMenu(index) {
      this.menuIndex = index;
      this.menuList.some((item) => {
        var bool = item.name === index;
        if (bool) {
          this.redirectByPath(item.url);
          return true;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.admin {
  // header
  .admin__header {
    line-height: 80px;
    font-size: 14px;
    color: #ffffff;
    background: rgb(48, 65, 86);
    .admin__header-left {
      float: left;
      padding-top: 15px;
      margin-right: 20px;
    }
    .admin__header-right {
      float: right;
      span {
        padding-right: 20px;
      }
    }
  }
  // aside
  .admin__aside {
    overflow: hidden;
    font-size: 16px;
    color: #b6c6d5;
    background: rgb(48, 65, 86);
    /deep/ .admin__aside-menu {
      border-right: none;
      .el-menu-item,
      .el-submenu__title {
        i {
          color: inherit;
        }
      }
    }
  }
}
</style>
